import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "selectedCounter"]

  connect() {
    this.setupSingleToggleCallbacks()

    this.updateSelectedCounter()
  }

  setupSingleToggleCallbacks() {
    const element = this.hasContainerTarget ? this.containerTarget : this.element

    $(element).on("click", ".bulk-select", this.handleToggleSingle.bind(this))
  }

  handleToggleSingle(evt) {
    evt.target.checked === true ? this.enableBulkActions() : this.maybeDisableBulkActions()

    this.updateSelectedCounter()
    this.updateSelectAllCheckbox()
    this.updateGroupSelectAllCheckbox(evt.target)
  }

  handleToggleAll(evt) {
    let checked = evt.target.checked
    this.coerceAllSelections(checked)
    checked === true ? this.maybeEnableBulkActions() : this.disableBulkActions()

    this.updateSelectedCounter()
  }

  updateSelectedCounter() {
    if (!this.hasSelectedCounterTarget) {
      return
    }

    this.selectedCounterTarget.textContent = this.getSelectedIdsCount()
  }

  coerceAllSelections(checked) {
    $(".bulk-select:not(:disabled):visible", this.rootElement)
      .prop("checked", checked)
      .each((idx, element) => element.dispatchEvent(new Event("change")))
  }

  enableBulkActions() {
    $(".bulk-buttons button, .bulk-buttons a", this.rootElement).removeClass("disabled").attr("disabled", false)
  }

  disableBulkActions() {
    $(".bulk-buttons button, .bulk-buttons a", this.rootElement).addClass("disabled").attr("disabled", true)
  }

  maybeEnableBulkActions() {
    if ($(".bulk-select:not(:disabled):checked", this.rootElement).length > 0) {
      this.enableBulkActions()
    }
  }

  maybeDisableBulkActions() {
    if ($(".bulk-select:not(:disabled):checked", this.rootElement).length === 0) {
      this.disableBulkActions()
    }
  }

  bulkCategorize() {
    $("#bulk_update_ids", this.rootElement).val(this.getSelectedIds())
    $("#bulk-categorize-modal").modal()
  }

  bulkTask() {
    const agent_ids = this.getSelectedIds()
    let attr
    if (document.getElementById("bulk-task-button").dataset.attribute) {
      attr = document.getElementById("bulk-task-button").dataset.attribute
    } else {
      attr = "agent_ids"
    }
    const href = document.getElementById("bulk-task-button").dataset.url + "?" + attr + "=" + agent_ids
    window.location.href = href
  }

  bulkMove() {
    $("#bulk_update_agent_ids", this.rootElement).val(this.getSelectedIds())
    $("#bulk-move-modal").modal()
  }

  bulkUninstall() {
    $("#bulk_uninstall_agent_ids", this.rootElement).val(this.getSelectedIds())
    $("#bulk-uninstall-modal").modal()
  }

  handleToggleGroup(evt) {
    const checked = evt.target.checked
    const groupBody = evt.target.closest("tbody")
    $(".bulk-select:not(:disabled):visible", groupBody)
      .prop("checked", checked)
      .each((idx, element) => element.dispatchEvent(new Event("change")))
    checked ? this.maybeEnableBulkActions() : this.maybeDisableBulkActions()
    this.updateSelectedCounter()
  }

  updateGroupSelectAllCheckbox(checkbox) {
    const groupBody = checkbox.closest("tbody")
    if (!groupBody) return
    const groupSelectAll = groupBody.querySelector("[data-action*='handleToggleGroup']")
    if (!groupSelectAll) return
    const eligible = groupBody.querySelectorAll(".bulk-select:not(:disabled)")
    const checkedBoxes = groupBody.querySelectorAll(".bulk-select:not(:disabled):checked")
    groupSelectAll.checked = eligible.length > 0 && eligible.length === checkedBoxes.length
  }

  updateSelectAllCheckbox() {
    let eligibleCheckboxes = $("tr:not(.hide) .bulk-select:not(:disabled)", this.rootElement)
    let checkedCheckboxes = eligibleCheckboxes.filter(":checked")
    let allChecked = eligibleCheckboxes.length > 0 && eligibleCheckboxes.length === checkedCheckboxes.length

    $("#bulk-select-all", this.rootElement).prop("checked", allChecked)
  }

  getSelectedIds() {
    const selections = this.rootElement.querySelectorAll(".bulk-select:checked")
    return [...selections].map(selection => selection.dataset.id).join(", ")
  }

  getSelectedIdsCount() {
    const selections = this.rootElement.querySelectorAll(".bulk-select:checked")
    return selections.length
  }

  getSelectedRows() {
    const selections = this.rootElement.querySelectorAll(".bulk-select:checked")
    return [...selections].map(selection => selection.closest("tr"))
  }

  get rootElement() {
    // bulk actions controller can be scoped to only search within a certain element
    return this.element.dataset.rootNode ? document.querySelector(this.element.dataset.rootNode) : document
  }
}
